module.exports = __webpack_public_path__ + "static/media/bosses.8a405a1f.jpg";